import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MemberEnrollmentDetailsPacim } from '@core/model/member-enrollment-details-pacim';
import { MemberPacService } from '@core/service';
import { BehaviorSubject, Observable, catchError, map, of, switchMap } from 'rxjs';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'enrollment-details-pac',
    templateUrl: './enrollment-details-pac.component.html',
    styleUrls: ['./enrollment-details-pac.component.scss'],
    standalone: false
})
export class EnrollmentDetailsPacimComponent implements OnInit, OnChanges {
  @Input() tenantId: string;
  @Input() memberId: string;
  @Output() ShowErrorMsg = new EventEmitter<boolean>();
  @Input() showGroupId : boolean = false;
  @Input() groupId: string;

  enrollmentDetails$: Observable<MemberEnrollmentDetailsPacim>;

  private loadEnrollmentData$ = new BehaviorSubject<string>(null);

  pacEligibilityMessage = '';
  pacErrorMessages: string[] = [];

  constructor(private readonly memberPacService: MemberPacService) { }

  ngOnInit(): void {
    this.enrollmentDetails$ = this.loadEnrollmentData$.pipe(
      switchMap(memberId => memberId ?
        this.memberPacService.getMemberEnrollmentDetails(
          this.tenantId,
          memberId
        ).pipe(catchError(err => {
          if(err.status === 403)
            this.ShowErrorMsg.emit(true);
          return of({} as MemberEnrollmentDetailsPacim)
        })) : of({} as MemberEnrollmentDetailsPacim)),
      map(data => {
        const enrollmentData = data || ({} as MemberEnrollmentDetailsPacim);

        this.pacEligibilityMessage = enrollmentData.pacEligibilityStatus;
        this.pacErrorMessages = enrollmentData.pacErrorMessages || [];

        return enrollmentData;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.memberId?.currentValue) {
      this.loadEnrollmentData$.next(changes.memberId.currentValue);
    }
  }

}
